import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./Branding_Why_Choose_Us.css";
import Print_Media_Why_Choose_Us_list_card from "../../../Common_Component/Print_Media_Why_Choose_Us_list_card/Print_Media_Why_Choose_Us_list_card";

function Branding_Why_Choose_Us(props) {
  const [whyChooseData, setWhyChooseData] = useState([]);
  const { id } = useParams(); // Get 'id' from the URL params

  // Static data array
  const data = [
    {
      id: 1,
      whyChooseData: [
        {
          title: "Creative Expertise",
          subtext:
            "Our designers specialize in creating logos that are creative, meaningful, and aligned with your brand.",
          imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img1.png",
        },
        {
          title: "Collaborative Process",
          subtext: "We involve you at every step to ensure your satisfaction.",
          imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img2.png",
        },
        {
          title: "Attention to Detail",
          subtext:
            "From typography to colour palette, we focus on every element to create a cohesive design.",
          imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img3.png",
        },
        {
          title: "Quick Turnaround",
          subtext:
            "Get your logo delivered promptly without compromising on quality.",
          imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img4.png",
        },
        // {
        //   title: "CTA:",
        //   subtext:
        //     "Ready to craft a logo that defines your brand? Let’s bring your vision to life with a design that resonates. Contact us today to get started!",
        //   imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img4.png",
        // },
      ],
    },
    {
      id: 2,
      whyChooseData: [
        {
          title: "Creative Expertise",
          subtext:
            "Our designers blend creativity and strategy to deliver impactful designs.",
          imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img1.png",
        },
        {
          title: "Customized Solutions",
          subtext:
            "Every design is tailored to suit your unique needs.",
          imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img2.png",
        },
        {
          title: "Quick Turnaround",
          subtext:
            "Timely delivery without compromising quality.",
          imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img3.png",
        },
        {
          title: "End-to-End Support",
          subtext:
            "From brainstorming to final delivery, we ensure a seamless experience.",
          imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img4.png",
        },
        // {
        //   title: "CTA",
        //   subtext:
        //     "Is your brand ready to stand out? Let us help you craft a custom logo that speaks to your audience. Contact us now to start the journey!",
        //   imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img5.png",
        // },
      ],
    },
    {
      id: 3,
      whyChooseData: [
        {
          title: "Tailored Approach",
          subtext:
            "Designs customized to your business goals and target audience.",
          imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img1.png",
        },
        {
          title: "Creative Excellence",
          subtext:
            "Innovative designs that balance aesthetics and strategy.",
          imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img2.png",
        },
        {
          title: "End-to-End Solutions",
          subtext:
            "From concept to final delivery, we manage every step.",
          imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img3.png",
        },
        {
          title: "Brand Longevity",
          subtext:
            "Designs that stand the test of time and adapt with your growth.",
          imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img4.png",
        },
        // {
        //   title: "CTA",
        //   subtext:
        //     "Ready to create a brand that leaves a lasting impression? Let’s design a visual identity that tells your story. Contact us today to get started!",
        //   imgSrc: "/Assets/Images/Service/Services/Branding/why_choose/img5.png",
        // },
      ],
    },
  ];

  // Filter the data based on the 'id' from the URL
  useEffect(() => {
    const filteredArray = data.filter((item) => item.id === Number(id));
    setWhyChooseData(filteredArray);
  }, [id]);

  return (
    <section className="Print_Media_Why_Choose_Us Branding_Why_Choose_Us">
      <div className="container">
        <div className="main_Branding_Why_Choose_Us">
          <div className="main_heading_holder">
            <div className="heading_holder">
              <h3>
                Why <br /> Choose Us?
              </h3>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xl-8 col-md-7 p-0 order-md-1 order-2">
              <div className="main_content_holder">
                <div className="content_holder">
                  {whyChooseData.length > 0 &&
                    whyChooseData[0].whyChooseData.map((item, index) => (
                      <div className="Print_Media_Why_Choose_Us_list" key={index}>
                        <Print_Media_Why_Choose_Us_list_card
                          title={item?.title}
                          imgSrc={item?.imgSrc}
                          subtext={item?.subtext}
                        />
                      </div>
                    ))}
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-md-5 col-sm-5 col-6 p-0 order-md-2 order-1">
              <div className="main_img_holder">
                <img
                  className="Print_Media_img"
                  src="/Assets/Images/Service/Services/Branding/why_choose/right_img.png"
                  alt="Print_Media_img"
                />
                <div className="overlay_holder"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Branding_Why_Choose_Us;
